import { render, staticRenderFns } from "./general-alert.vue?vue&type=template&id=567cd699&scoped=true&"
import script from "./general-alert.vue?vue&type=script&lang=js&"
export * from "./general-alert.vue?vue&type=script&lang=js&"
import style0 from "./general-alert.vue?vue&type=style&index=0&id=567cd699&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567cd699",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567cd699')) {
      api.createRecord('567cd699', component.options)
    } else {
      api.reload('567cd699', component.options)
    }
    module.hot.accept("./general-alert.vue?vue&type=template&id=567cd699&scoped=true&", function () {
      api.rerender('567cd699', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/general-alert.vue"
export default component.exports